/**
 * **记牌器表头 / A2 选牌的那张小牌** —— 现在复用 `CardActor`（`CardView` + `CardRig`），
 * 于是它和手牌一样有 idle 摇摆、hover 抬起、出血裁切；不再是"直接渲染一张图"。
 *
 * 界面层不许自己挂指针事件（`test/ui/design.test.ts`），所以这层收进组件。
 */
import type { Container } from 'pixi.js';
import type { CardDef } from '../../core/card';
import type { CardFaceCache } from '../card/faceCache';
import { CardActor } from './cardActor';

export interface TrackerHeaderOptions {
  readonly faces: CardFaceCache;
  readonly def: CardDef;
  readonly width: number;
  readonly height: number;
  /** 指着这张 / `null` = 移开 */
  readonly onHover?: (def: CardDef | null) => void;
  /** 点这张牌（从弃牌堆捞一张用） */
  readonly onPick?: () => void;
}

export class TrackerHeader {
  readonly view: Container;
  readonly def: CardDef;
  readonly #actor: CardActor;

  constructor(options: TrackerHeaderOptions) {
    this.def = options.def;
    this.#actor = new CardActor({
      faces: options.faces,
      def: options.def,
      height: options.height,
      clip: true,
      ...(options.onHover === undefined ? {} : { onHover: options.onHover }),
      ...(options.onPick === undefined ? {} : { onPick: options.onPick }),
    });
    this.view = this.#actor.view;
  }

  /** 每帧推 idle / hover */
  update(dtMs: number): void {
    this.#actor.update(dtMs);
  }

  pulse(): void {
    this.#actor.pulse();
  }

  destroy(): void {
    this.#actor.destroy();
  }
}
